/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Loggia_AreaInputs */

const cs_form_loggia_area = /** @type {(inputs: Form_Loggia_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plocha lodžie (m²)`)
};

const en_form_loggia_area = /** @type {(inputs: Form_Loggia_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loggia area (m²)`)
};

/**
* | output |
* | --- |
* | "Loggia area (m²)" |
*
* @param {Form_Loggia_AreaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_loggia_area = /** @type {((inputs?: Form_Loggia_AreaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Loggia_AreaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_loggia_area(inputs)
	return cs_form_loggia_area(inputs)
});